class ComponentSearch extends HTMLElement {
  constructor() {
    super();
    this.searchField = this.querySelector('input[name="q"]');
    this.tagField = this.querySelector('.search-tag');
    this.results = document.querySelector('.search-results');
    this.status = document.getElementById('search-autocomplete-status');
    this.btn = this.querySelector('.search-btn');
    this.form = this.querySelector('form');
    this.searchDelay = 300;
    this.searchType = 'product';
    this.controller = null;
    this.requestTimeout = 0;
    this.activeIndex = -1;

    if (this.dataset.autocomplete === "true") {
      this.documentClickHandler = this.documentClick.bind(this);
      this.searchField.addEventListener('input', this.doSearch.bind(this));
      this.instructions = document.getElementById('search-autocomplete-instructions');
      this.searchField.addEventListener('focus', this.onSearchFocus.bind(this));
      this.searchField.addEventListener('blur', this.onSearchBlur.bind(this));
      this.searchField.addEventListener('keydown', this.onSearchKeydown.bind(this));
    }

    this.form.addEventListener('submit', (e)=>{
      e.preventDefault();
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const query = searchParams.get('q');
      if(query && query!=="") {
        searchParams.set('q', '*'+query+'*'+"|tag:"+this.tagField.value);
        var searchParamsString = searchParams.toString();
        searchParamsString = searchParamsString.replace("%7C", "+");
        clearTimeout(this.requestTimeout);
        if(this.controller)  this.controller.abort();
        this.clearResults();
        //return false;
        location.href = this.form.action + '?' + searchParamsString;
      }
    });

    if(this.btn) {
      this.btn.addEventListener('mousedown', (e)=>{ 
        e.preventDefault();
        this.form.submit();
      });
    }
  }

  //term param allows to trigger custom search from js code.
  doSearch(term) {
    term = typeof(term)=="string" ? term : '*'+this.searchField.value.trim()+'*';
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
    clearTimeout(this.requestTimeout);
    if (term.length>=5) {
      this.showSearchingResults();
      this.requestTimeout = setTimeout(()=>{
        this.controller = $s.getJson({
          url: '/search?view=ajax_json&type='+ this.searchType +'&q='+ encodeURIComponent(term) + "+tag:" + encodeURIComponent(this.tagField.value),
          success: (response)=>{
            this.clearResults(false);
            if (response.results_count > 0) {
              response.results.forEach((item)=>{
                this.results.appendChild(this.buildItem(item));
              });
              if (response.results_count > response.results.length) {
                var linkUrl = '/search?type='+ this.searchType +'&q='+ encodeURIComponent(term);
                this.results.appendChild(this.buildSeeAllLink(linkUrl, response.results_count));
              }
              this.announceResults(response.results.length, response.results_count);
            } else {
              this.noResults();
            }
          }
        });
      }, this.searchDelay);
    } else {
      this.clearResults();
    }
  }

  buildItem(itemJson) {
    var img = document.createElement('img');
    var title = document.createElement('div');
    var a = document.createElement('a');
    a.classList.add("item", "flex", "flex-1", "direction-row", "justify-content-start", "align-items-center");
    a.href = itemJson.url;
    a.setAttribute('role', 'option');
    this.prepareOption(a);
    img.src = itemJson.thumbnail;
    img.setAttribute('alt', '');
    title.innerHTML = itemJson.title;
    a.appendChild(img);
    a.appendChild(title);
    return a;
  }

  buildSeeAllLink(url, resultsQuantity) {
    var a = document.createElement('a');
    a.classList.add('see-all');
    a.href = url;
    a.setAttribute('role', 'option');
    a.innerHTML = 'See all ' + resultsQuantity + ' results';
    this.prepareOption(a);
    return a;
  }

  prepareOption(el) {
    el.id = 'search-autocomplete-option-' + (this.optionSeq = (this.optionSeq || 0) + 1);
    el.setAttribute('aria-selected', 'false');
    el.setAttribute('tabindex', '-1');
  }

  showSearchingResults() {
    if (!this.results.style.minHeight) {
      document.addEventListener('click', this.documentClickHandler);

      var height = this.results.offsetHeight;
      this.results.style.minHeight = Math.max(height, 80)  + 'px';
      this.results.innerHTML = '<div style="height: 100%;" class="loader-wrap flex justify-content-center align-items-center"><div class="loader" style="border-top-color: #ccc;"></div></div>';
      this.searchField.setAttribute('aria-expanded', 'true');
    }
  }

  clearResults(removeEvents=true) {
    if(removeEvents) {
      document.removeEventListener('click', this.documentClickHandler);
    }
    this.results.innerHTML = '';
    this.results.style.minHeight = '';
    this.resetActiveOption();
    // removeEvents=false means we are repopulating the still-visible listbox.
    if (removeEvents) {
      this.searchField.setAttribute('aria-expanded', 'false');
      this.announce('');
    }
  }

  noResults() {
    this.results.innerHTML = '<div class="no-results">No results</div>';
    this.announce('No results available.');
  }

  announceResults(shown, total) {
    var suggestions = total > shown ? shown + 1 : shown;
    this.announce(suggestions === 1 ? '1 result available.' : suggestions + ' results available.');
  }

  announce(message) {
    if (!this.status) return;
    this.status.textContent = message;
  }

  getOptions() {
    return Array.from(this.results.querySelectorAll('[role="option"]'));
  }

  onSearchKeydown(e) {
    var options = this.getOptions();

    if (e.key === 'Escape') {
      if (options.length) e.preventDefault();
      this.clearResults();
      return;
    }

    if (e.key === 'Enter') {
      var active = options[this.activeIndex];
      if (active) {
        e.preventDefault();
        this.clearResults();
        location.href = active.href;
      }
      return;
    }

    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    if (!options.length) return;

    e.preventDefault();
    var last = options.length - 1;
    if (e.key === 'ArrowDown') {
      this.setActiveOption(this.activeIndex >= last ? 0 : this.activeIndex + 1);
    } else {
      this.setActiveOption(this.activeIndex <= 0 ? last : this.activeIndex - 1);
    }
  }

  setActiveOption(index) {
    var options = this.getOptions();
    options.forEach((option, i)=>{
      var isActive = i === index;
      option.setAttribute('aria-selected', isActive ? 'true' : 'false');
      option.classList.toggle('is-active', isActive);
    });
    this.activeIndex = index;
    var active = options[index];
    if (active) {
      this.searchField.setAttribute('aria-activedescendant', active.id);
      if (active.scrollIntoView) active.scrollIntoView({block: 'nearest'});
    } else {
      this.searchField.removeAttribute('aria-activedescendant');
    }
  }

  resetActiveOption() {
    this.activeIndex = -1;
    this.searchField.removeAttribute('aria-activedescendant');
  }

  documentClick(e) {
    if(!this.contains(e.target)) {
      this.clearResults();
    }
  }

  onSearchFocus() {
    if (this.instructions) {
      this.instructions.setAttribute('aria-hidden', 'false');
    }
  }

  onSearchBlur() {
    if (this.instructions) {
      this.instructions.setAttribute('aria-hidden', 'true');
    }
  }
}
customElements.define('search-form', ComponentSearch);